module.exports = __webpack_public_path__ + "img/add_btn_icon481.3c285868.svg";